export default __webpack_public_path__ + "static/all-caps-dont-0fd57f08caa6641669d8de2aa86ff4cb9f47ca9469b7eab6b5dad79fee9e3a82.png";